import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from '../sidebar.module.css';

import { ReactComponent as AuthenticateLogo } from 'asset/img/authenticate_rgb.svg';

function BrandHeader({ className }) {
    return (
        <Box className={clsx(styles.brandHeader, className)}>
            <AuthenticateLogo
                className={styles.authenticateLogo}
                role="img"
                aria-label="Authenticate"
            />
        </Box>
    );
}

BrandHeader.propTypes = {
    className: PropTypes.string,
};

export default BrandHeader;
